<template>
  <div class="map-container">
    <loading-spinner class="center" v-if="tracks.length == 0"></loading-spinner>
    <leaflet-map
      v-if="tracks.length > 0"
      :map_id="'47860821452'"
      :tracks="this.tracks"
      :color="'#f8ed4b'"
      :showMapSelect="true"
      :showLegend="true"
    />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";

import LeafletMap from "@/components/Maps/LeafletMap";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ActivityRepository = RepositoryFactory.get("activities");
export default {
  components: {
    LeafletMap,
    LoadingSpinner,
  },
  data() {
    return {
      loading: false,
      tracks: [],
    };
  },
  computed: {},
  created() {
    this.fetchRoutes().then((result) => (this.tracks = result));
  },
  methods: {
    async fetchRoutes() {
      try {
        const { data } = await ActivityRepository.getRoutes();
        return data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.activity-title {
  color: #fff;
  margin-bottom: 25px;
}

.map-container {
  overflow-y: hidden;
  position: relative;
  height: 96.6vh;
  overflow: hidden;
  width: 100%;
}
</style>